import { isPostalCode } from 'validator';
import * as Yup from 'yup';

import { logError } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { COUNTRY_CODES } from '@savgroup-front-common/constants';
import { globalMessages, isAddress } from '@savgroup-front-common/core/helpers';
import { UnknownOption } from '@savgroup-front-common/types';
import { AutocompleteOption } from '@savgroup-front-common/types';

const CustomerInformationAddressSchema = Yup.object().shape({
  address: Yup.string()
    .required(globalMessages.form.required)
    .test('is-address', globalMessages.form.invalidAddress, (value) => {
      return isAddress(value);
    }),
  additionalAddress: Yup.string().nullable(),
  postalCode: Yup.string()
    .required(globalMessages.form.required)
    .when(
      'countryCode',
      ([countryCode]: AutocompleteOption[], schema: Yup.StringSchema) => {
        const countryCodeValue = countryCode?.value || '';

        return schema.test(
          'test-postal-code',
          globalMessages.form.invalidPostalCode,
          (postalCode): boolean => {
            if (
              postalCode &&
              countryCodeValue?.toUpperCase() === COUNTRY_CODES.NL
            ) {
              return /^\d{4}\s?[A-Z]{2}$/i.test(postalCode);
            }

            try {
              return (
                !countryCodeValue ||
                !postalCode ||
                isPostalCode(postalCode, countryCodeValue.toUpperCase() as any)
              );
            } catch (error) {
              logError(error);

              return true;
            }
          },
        );
      },
    ),
  city: Yup.string().required(globalMessages.form.required),
  countryCode: Yup.object()
    .test(
      'countryCode',
      globalMessages.form.required,
      function test(option: UnknownOption) {
        return Boolean(option?.value);
      },
    )
    .required(globalMessages.form.required),
});

export default CustomerInformationAddressSchema;
